import React, { useState, useEffect } from 'react';
import { Grid, Paper } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import Layout from 'components/Layout/Layout';
import { DataRangeFilter } from 'components/DataRangeFilter/DataRangeFilter';
import { SITES } from 'queries/site';
import PageError from '../../../components/PageError';
import PageTitle from '../../../components/PageTitle/PageTitle';

import useStyles from '../components/styles';
import { UpdateSiteSettings } from '../components/edit';

interface ISite {
  languages: string[];
  id: string;
}

const SiteSettings: React.FC = () => {
  const classes = useStyles();

  const [sitesFilter, setSitesFilter] = useState<string[]>([]);
  const [sites, setSites] = useState([]);
  const [siteLanguages, setSiteLanguages] = useState<ISite>();

  const { data: sitesData, loading, error, refetch } = useQuery(SITES, {
    variables: {
      hosted: 'Wordpress',
    },
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (sitesData) {
      const fetchedSites = sitesData.sites.map((site: any) => site.domain);
      setSites(fetchedSites);
    }
  }, [sitesData]);

  useEffect(() => {
    if (sitesFilter.length) {
      const domain = sitesFilter[0];

      setSiteLanguages(
        () => sitesData.sites.find((site: any) => site.domain === domain),
        // eslint-disable-next-line function-paren-newline
      );
    }
  }, [sitesFilter, sitesData]);

  const permissions = {
    showSitesFilter: true,
  };

  return (
    <Layout>
      <Grid container spacing={0}>
        <Grid item xs={2}>
          <PageTitle title="Site Settings" />
        </Grid>
        <Grid xs={5} item />
        <Grid item xs={5}>
          <DataRangeFilter
            filterSite={sitesFilter}
            setFilterSite={(setSitesFilter as unknown) as null}
            sites={sites}
            permissions={(permissions as unknown) as null}
            customColumnSize={12}
          />
        </Grid>
      </Grid>
      {loading || !siteLanguages ? (
        <Paper className={classes.paper}>Please, select a site.</Paper>
      ) : error ? (
        <PageError />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper className={classes.paper}>
              <UpdateSiteSettings data={siteLanguages} refetch={refetch} />
            </Paper>
          </Grid>
        </Grid>
      )}
    </Layout>
  );
};

export default SiteSettings;
